var c = Object.defineProperty;
var o = (a, e, s) => e in a ? c(a, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : a[e] = s;
var t = (a, e, s) => o(a, typeof e != "symbol" ? e + "" : e, s);
import { createContext as p } from "react";
const d = p();
class N {
  constructor() {
    t(this, "getUsedNamespaces", () => Object.keys(this.usedNamespaces));
    this.usedNamespaces = {};
  }
  addUsedNamespaces(e) {
    e.forEach((s) => {
      this.usedNamespaces[s] || (this.usedNamespaces[s] = !0);
    });
  }
}
export {
  d as I18nContext,
  N as ReportNamespaces
};
